import React from "react";
import { useParams } from "react-router-dom";
import ViewDocs from "./viewDocs";
import useWindowWidth from "./useWindowWidth";

const Stats = ({ uuid, widthMax }) => {
    const { courseCode, assessmentCode } = useParams();
    const width = useWindowWidth(widthMax ? widthMax : 435);

    return (
        <>
            {
                !width && (
                    <ViewDocs path={`/${courseCode}/${assessmentCode}/statistics?uuid=${uuid}`} name={'Statistics'}/>
                )
            }            
        </>
    );
}

export default Stats;